import SEO from "@/components/feature/SEO";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import HeroSection from "./components/HeroSection";
import FeaturedVideos from "./components/FeaturedVideos";
import CategoryGrid from "./components/CategoryGrid";
import LatestArticles from "./components/LatestArticles";

export default function Home() {
  return (
    <>
      <SEO
        title="红桃视频网页版 - 免费在线观看高清视频 | 红桃视频官网网页版"
        description="红桃视频网页版为您提供海量高清视频在线免费观看体验，无需下载安装，打开浏览器即可畅享。支持多终端访问，PC端、手机端均可流畅播放，内容丰富，更新及时，是您娱乐休闲的首选视频平台。"
        keywords="红桃视频网页版,红桃视频在线观看,红桃视频PC端,红桃视频免费播放,红桃视频高清,红桃视频网址入口,红桃视频官网网页版"
        canonical="https://www.hongtao-video.com/"
        ogTitle="红桃视频网页版 - 免费在线观看高清视频"
        ogDescription="红桃视频网页版为您提供海量高清视频在线免费观看体验，无需下载安装，打开浏览器即可畅享。"
        ogUrl="https://www.hongtao-video.com/"
      />

      <ScrollToTop />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "红桃视频网页版",
            url: "https://www.hongtao-video.com/",
            description: "红桃视频网页版为您提供海量高清视频在线免费观看体验",
            sameAs: ["https://weibo.com/hongtao", "https://space.bilibili.com/hongtao"],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "红桃视频网页版 - 免费在线观看高清视频",
            url: "https://www.hongtao-video.com/",
            description: "红桃视频网页版为您提供海量高清视频在线免费观看体验",
            isPartOf: { "@type": "WebSite", name: "红桃视频网页版", url: "https://www.hongtao-video.com/" },
          }),
        }}
      />

      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-1">
          <HeroSection />
          <FeaturedVideos />
          <CategoryGrid />
          <LatestArticles />
        </main>
        <Footer />
      </div>
    </>
  );
}